const arrayFilters = new Set([
  'type', 'collection_slug', 'price', 'duration', 'group_size', 'venue_type',
  'listing_type', 'insurance_coverage', 'city_location', 'platform_location',
  'vibe_ids', 'category_ids', 'rating'
]);

// Keep the existing multi-select format compatible with saved links. A single
// selection is an ordinary query value, not a one-element JSON array.
export function cleanDiscoverParams(params, pathname) {
  const clean = new URLSearchParams(params);
  for (const key of arrayFilters) {
    const raw = clean.get(key);
    if (!raw?.trim().startsWith('[')) continue;
    try {
      const values = JSON.parse(raw);
      if (!Array.isArray(values)) continue;
      const selected = [...new Set(values.filter(value => value != null && value !== '').map(String))];
      if (!selected.length) clean.delete(key);
      else clean.set(key, selected.length === 1 ? selected[0] : JSON.stringify(selected));
    } catch { /* Preserve malformed legacy values for the server to handle. */ }
  }
  for (const [key, value] of [...clean]) {
    if (value === '') clean.delete(key);
  }
  const impliedType = pathname === '/activities/virtual' ? 'Virtual'
    : pathname === '/activities/in-person' ? 'In-Person' : null;
  if (clean.get('type') === impliedType || clean.get('type') === 'All Experiences') clean.delete('type');
  if (clean.get('page') === '1') clean.delete('page');
  if (clean.get('sort') === 'magic') clean.delete('sort');
  return clean;
}

export function writeDiscoverHistory(url, { replace = false, browser = window } = {}) {
  const target = new URL(url, browser.location.href);
  const current = new URL(browser.location.href);
  // Parameter ordering is not a new search and must not create a Back stop.
  const sorted = value => { const params = new URLSearchParams(value); params.sort(); return params.toString(); };
  if (target.pathname === current.pathname && target.hash === current.hash &&
      sorted(target.search) === sorted(current.search)) return;
  browser.history[replace ? 'replaceState' : 'pushState']({}, '', target.pathname + target.search + target.hash);
}
